<template>
  <transition name="fade">
    <div v-if="show" class="overlay">
      <div class="toast">
        <div class="toast-header">
          <h3 class="toast-title">{{ title }}</h3>
        </div>
        <div class="toast-body">
          <p>{{ body }}</p>
        </div>
        <div class="toast-actions">
          <button v-if="secondaryButton" class="btn btn-secondary" @click="secondaryButton.onClick">
            {{ secondaryButton.label }}
          </button>
          <button v-if="primaryButton" class="btn btn-primary" @click="primaryButton.onClick">
            {{ primaryButton.label }}
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    name: 'GiveUpToast',
    props: {
      title: { type: String, required: true },
      body: { type: String, required: true },
      show: { type: Boolean, required: true },
      primaryButton: { type: Object, default: null }, // { label, onClick }
      secondaryButton: { type: Object, default: null }, // { label, onClick }
    },
    emits: ['close'],
  };
</script>

<style scoped>
  /* Overlay atrás */
  .overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2000;
  }

  /* Caixa central */
  .toast {
    background: rgba(76, 76, 103, 1);
    color: rgb(223, 223, 223);
    border-radius: 16px;
    max-width: 400px;
    width: 90%;
    padding: 20px;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.4);
    display: flex;
    flex-direction: column;
    animation: pop 0.25s ease;
  }

  .toast-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
  }

  .toast-title {
    margin: 0;
    font-size: 1.2rem;
    font-weight: 600;
    width: 100%;
  }

  .toast-close {
    background: transparent;
    border: none;
    font-size: 1.5rem;
    color: #aaa;
    cursor: pointer;
  }
  .toast-close:hover {
    color: #fff;
  }

  .toast-body {
    margin-bottom: 16px;
    font-size: 0.95rem;
    line-height: 1.4;
  }

  .toast-actions {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
  }

  .btn {
    padding: 8px 16px;
    border-radius: 8px;
    font-size: 0.9rem;
    font-weight: 500;
    cursor: pointer;
    border: none;
  }

  .btn-primary {
    height: 44px;
    width: 100%;
    cursor: pointer;
    background-color: rgba(147, 147, 236, 1);
    color: rgba(26, 26, 26, 1);
    border: 1px rgba(147, 147, 236, 1);
    padding: 6px 12px;
    border-radius: 12px;
    transition: background-color 0.3s;
    font-size: 14px;
    font-family: 'Oxygen', Helvetica, Arial, sans-serif;
    font-weight: 700;
    box-sizing: border-box;
  }

  .btn-primary:hover {
    background-color: rgba(184, 184, 249, 1);
  }

  .btn-secondary {
    height: 44px;
    width: 100%;
    cursor: pointer;
    background-color: transparent;
    color: rgba(147, 147, 236, 1);
    border: 2px rgba(147, 147, 236, 1) solid;
    padding: 6px 12px;
    border-radius: 12px;
    transition: background-color 0.3s;
    font-size: 14px;
    font-family: 'Oxygen', Helvetica, Arial, sans-serif;
    font-weight: 700;
    box-sizing: border-box;
  }

  .btn-secondary:hover {
    background-color: rgba(0, 0, 0, 0.2);
  }

  /* animação de fade */
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.3s ease;
  }
  .fade-enter-from,
  .fade-leave-to {
    opacity: 0;
  }

  @media screen and (max-width: 480px) {
    .toast {
      max-width: 80%;
    }
  }

  /* leve pop-in */
  @keyframes pop {
    0% {
      transform: scale(0.9);
      opacity: 0;
    }
    100% {
      transform: scale(1);
      opacity: 1;
    }
  }
</style>
